module.exports = __webpack_public_path__ + "static/Portrait-of-Zach-min-e093e4e59df6f7007fe8b315603d82a7.jpg";